import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { checkoutUrl, offer } from '../data/content';
export function Pricing() {
  return <section id="planes" className="w-full bg-blue-50 py-14 md:py-20" data-id="element-197" data-mp="2oipjx0chn5gh">
      <div className="mx-auto w-full max-w-5xl px-5 md:px-8" data-id="element-198" data-mp="2ohxmrl38szo3">
        <h2 className="mx-auto max-w-3xl text-center text-3xl font-extrabold leading-tight tracking-tight text-slate-900 md:text-5xl" data-id="element-199" data-mp="2jknr3np9frrt">
          {offer.title}
        </h2>

        <div className="mx-auto mt-10 max-w-3xl rounded-2xl bg-white p-6 shadow-lg ring-2 ring-blue-600 sm:p-7 md:p-10" data-id="element-200" data-mp="1rsq2shi9uyma">
          <p className="text-center text-xl font-extrabold uppercase tracking-tight text-slate-900 md:text-2xl" data-id="element-201" data-mp="25shjwr434v4i">
            {offer.name}
          </p>
          <p className="mt-1 text-center text-lg font-semibold text-blue-600" data-id="element-202" data-mp="20vhg6mupk4gk">{offer.summary}</p>

          <ul className="mx-auto mt-8 grid max-w-2xl gap-4 text-left sm:grid-cols-2" data-id="element-203" data-mp="3h97m7z5e12su">
            {offer.includes.map(item => <li key={item} className="flex items-start gap-3" data-id="element-204" data-mp="3vzyncicgrb3m">
                <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-emerald-50 text-emerald-600" data-id="element-205" data-mp="3w1t7vvjtp176">
                  <CheckIcon className="h-4 w-4" aria-hidden="true" data-id="element-206" data-mp="9rp6xbkj2hpv" />
                </span>
                <span className="text-slate-900" data-id="element-207" data-mp="erv6rf0ybaj1">{item}</span>
              </li>)}
          </ul>

          <p className="mt-10 text-center text-6xl font-extrabold tracking-tight text-slate-900 md:text-7xl" data-id="element-208" data-mp="3d9qo4bbvx4sp">
            {offer.price}
            <span className="ml-2 text-2xl font-semibold text-blue-900/55" data-id="element-209" data-mp="3i8boqbv1tqho">{offer.currency}</span>
          </p>

          <div className="mt-7" data-id="element-210" data-mp="3n5238ur7ge0z">
            <CtaButton size="xl" className="w-full" href={checkoutUrl} data-id="element-211" data-mp="3rxljy0l6vpa0">
              {offer.cta}
            </CtaButton>
            <p className="mt-3 text-center text-sm text-blue-900/60" data-id="element-212" data-mp="2uhenpu4skdl7">{offer.note}</p>
          </div>
        </div>
      </div>
    </section>;
}